// SettingsSidebar.tsx
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Settings.scss";

interface MenuItem {
  label: string;
  to?: string;
  iconClass?: string;
  badge?: "NEW" | "BETA";
  external?: boolean;
  children?: MenuItem[];
}
const menu: { title: string; items: MenuItem[] }[] = [
  {
    title: "Einstellungen",
    items: [
      {
        label: "Benutzerverwaltung",
        to: "/user-settings",
        iconClass: "fa-solid fa-users",
        children: [
          {
            label: "Benutzer",
            to: "/user-settings",
            iconClass: "fa-solid fa-use1r",
          },
          {
            label: "Gruppen",
            to: "/user-settings",
            iconClass: "fa-solid fa-users-rectang1le",
          },
        ],
      },
      {
        label: "E-Mail-Einstellungen",
        to: "/email-settings",
        iconClass: "fa-solid fa-envelope",
        // add children
        children: [
          {
            label: "Vorlagen",
            to: "/email-settings",
            iconClass: "fa-solid fa-document",
          },
          {
            label: "OAuth-Einstellungen",
            to: "/email-settings",
            iconClass: "fa-solid fa-oauth",
          },
        ],
      },
      {
        label: "Telefonie-Einstellungen",
        to: "/phone-settings",
        iconClass: "fa-solid fa-phone",
        children: [
          {
            label: "Anrufweiterleitung",
            to: "/phone-settings",
            iconClass: "fa-solid fa-phone-arrow-right",
          },
          {
            label: "Voicemail",
            to: "/phone-settings",
            iconClass: "fa-solid fa-voicem2ail",
          },
        ],
      },

      {
        label: "Account verwalten",
        to: "/account-settings",
        iconClass: "fa-solid fa-user-cog",
      },
    ],
  },
];









const SettingsSidebar: React.FC = () => {
  const [openSections, setOpenSections] = useState<Record<string, boolean>>({});

  const toggleSection = (label: string) => {
    setOpenSections((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  return (
    <aside className="settings-sidebar">
      <div className="sidebar-header">
        <button className="back-button">
          <i className="fa-solid fa-arrow-left"></i>
          
        </button>
        <h2>Einstellungen</h2>
      </div>

      <nav>
        {menu.map((section) => (
          <div key={section.title} className="menu-section">
            <h3 className="section-title">{section.title}</h3>
            <ul>
              {section.items.map((item) => {
                const hasChildren = !!item.children;
                const isOpen = openSections[item.label];
                return (
                  <li key={item.label}>
                    {hasChildren ? (
                      <div
                        className="submenu-toggle"
                        onClick={() => toggleSection(item.label)}
                      >
                        <span>
                          {item.iconClass && <i className={item.iconClass} style={{marginRight:"5px"}}></i>}{" "}
                          {item.label}
                        </span>
                        <i className={`fa-solid ${isOpen ? "fa-chevron-up" : "fa-chevron-down"}`}></i>
                      </div>
                    ) : item.to ? (
                      <NavLink
                        to={item.to}
                        className={({ isActive }) =>
                          `menu-item${isActive ? " active" : ""}`
                        }
                      >
                        {item.iconClass && <i className={item.iconClass} style={{marginRight:"5px"}}></i>}
                        <span className="menu-label">{item.label}</span>
                        {item.badge && (
                          <span className={`badge badge-${item.badge.toLowerCase()}`}>
                            {item.badge}
                          </span>
                        )}
                        {item.external && (
                          <i className="fa-solid fa-up-right-from-square external-icon"></i>
                        )}
                      </NavLink>
                    ) : (
                      <span className="menu-item">
                        {item.iconClass && <i className={item.iconClass}></i>}
                        <span className="menu-label">{item.label}</span>
                      </span>
                    )}
                    {hasChildren && isOpen && (
                      <ul className="submenu">
                        {item.children!.map((sub) => (
                          <li key={sub.label}>
                            <NavLink
                              to={sub.to!}
                              className={({ isActive }) =>
                                `menu-item sub-item${isActive ? " active" : ""}`
                              }
                            >
                              {sub.iconClass && <i className={sub.iconClass}></i>}
                              <span>{sub.label}</span>
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </nav>
    </aside>
  );
};

export default SettingsSidebar;
